import React from "react";

const AuthFooter = () => {
  return (
    <div 
      className="nk-footer nk-auth-footer-full" 
      style={{ 
        backgroundColor: 'transparent',
        borderTop: 'none',
        border: 'none'
      }}
    >
    </div>
  );
};
export default AuthFooter;
